var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBasket(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    baseProfile: "tiny-ps",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "shp0",
    d: "M576 216L576 232C576 245.25 565.25 256 552 256L544 256L517.89 438.79C514.51 462.44 494.26 480 470.37 480L105.63 480C81.74 480 61.49 462.44 58.11 438.79L32 256L24 256C10.74 256 0 245.25 0 232L0 216C0 202.75 10.74 192 24 192L91.34 192L198.12 45.18C208.52 30.89 228.53 27.73 242.82 38.12C257.11 48.52 260.27 68.53 249.88 82.82L170.48 192L405.52 192L326.12 82.82C315.73 68.53 318.89 48.52 333.18 38.12C347.47 27.72 367.49 30.88 377.88 45.18L484.66 192L552 192C565.25 192 576 202.75 576 216ZM312 392L312 280C312 266.75 301.25 256 288 256C274.75 256 264 266.75 264 280L264 392C264 405.25 274.75 416 288 416C301.25 416 312 405.25 312 392ZM424 392L424 280C424 266.75 413.25 256 400 256C386.75 256 376 266.75 376 280L376 392C376 405.25 386.75 416 400 416C413.25 416 424 405.25 424 392ZM200 392L200 280C200 266.75 189.25 256 176 256C162.75 256 152 266.75 152 280L152 392C152 405.25 162.75 416 176 416C189.25 416 200 405.25 200 392Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBasket);
export default __webpack_public_path__ + "static/media/basket.b3aff60ea644d4eca82fa2ba5ce27df8.svg";
export { ForwardRef as ReactComponent };